<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>card_giftcard</mat-icon>
        <div>Produtos</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <!--
        <a target='_blank' mat-button href="knowledge_viewer/RY58ZPY4jf6fusaWb7jd" style='width:60px;'>
          <mat-icon class='icon-help'>help_outline</mat-icon>
        </a>
        -->

        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card id='table-body'>

    <mat-tab-group id='tabs'>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star</mat-icon>
          Ativo
        </ng-template>
        <!-- TABLE -->
        <mat-table [dataSource]="_productService.productDataSource" 
        #activeSort="matSort" matSort matSortDisableClear='true'>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>card_giftcard</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.created.seconds* 1000 | date: 'dd/MM/yyyy' }}
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='delete(element, true)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>
   
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star</mat-icon>
          Histórico
        </ng-template>
        <!-- TABLE -->
        <mat-table [dataSource]="_productService.productDataSourceHistory" 
        #historySort="matSort"  matSort matSortDisableClear='true'>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>card_giftcard</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.created.seconds* 1000 | date: 'dd/MM/yyyy' }}
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='delete(element, false)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-cancel' style='font-size:1.5em;'>
                  undo_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>

    </mat-tab-group>




  </mat-card>

</div>